import SlotsHistory from './SlotsHistory';
export default SlotsHistory;
